<template>
  <figure class="max-request">
    <figcaption v-if="node.title || node.caption" class="max-request__head">
      <span v-if="node.title" class="max-request__title">{{ node.title }}</span>
      <span v-if="node.caption" class="max-request__caption">{{ node.caption }}</span>
    </figcaption>
    <div class="max-request__body">
      <blockquote ref="text" class="max-request__text" style="white-space: pre-line">{{ node.text }}</blockquote>
      <button type="button" class="max-chip max-request__copy" @click="copy">
        {{ state === 'copied' ? ctx.labels.copied : state === 'selected' ? ctx.labels.selected : ctx.labels.copy }}
      </button>
    </div>
    <span class="max-sr-only" aria-live="polite">{{ state === 'copied' ? ctx.labels.copied : '' }}</span>
  </figure>
</template>

<script setup lang="ts">
import { onBeforeUnmount, ref } from 'vue'
import { useMaxContext } from '../runtime/context.ts'

const props = defineProps<{ node: any }>()
const ctx = useMaxContext()
const text = ref<HTMLElement | null>(null)
const state = ref<'idle' | 'copied' | 'selected'>('idle')
let timer: ReturnType<typeof setTimeout> | null = null

function reset () {
  if (timer) clearTimeout(timer)
  timer = setTimeout(() => { state.value = 'idle' }, 1800)
}

/** Without clipboard access the text is selected so the reader can copy it by hand */
function select () {
  if (!text.value || typeof window === 'undefined') return
  const range = document.createRange()
  range.selectNodeContents(text.value)
  const selection = window.getSelection()
  selection?.removeAllRanges()
  selection?.addRange(range)
  state.value = 'selected'
  reset()
}

async function copy () {
  try {
    await navigator.clipboard.writeText(String(props.node.text ?? ''))
    state.value = 'copied'
    reset()
  } catch {
    select()
  }
}

onBeforeUnmount(() => {
  if (timer) clearTimeout(timer)
})
</script>
